module.exports = __webpack_public_path__ + "media/images/sec_3-8-22ecef06dfea2fde4d4db4ec2c29735e.png";